module.exports = __webpack_public_path__ + "img/cardboard-box.17a7f54f.svg";